<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <SearchBar ref="searchRef" msg="A100" @search="onLoadTable" />
            </div>
            <div id="datablock" style="height: calc(100vh - 352px)">
                <el-row type="flex" justify="end">
                    <el-button type="primary" round plain @click="onPageChangeClick('order')" v-show="store.getters.check_auth('ADD')">匯入訂單</el-button>
                    <el-button type="primary" round plain @click="onExportClick" v-show="store.getters.check_auth('PRINT')">下載明細</el-button>
                </el-row>
                <div ref="table" style="margin-top:10px;"></div>

                <!-- 配達照片或簽收圖檔 -->
                <el-dialog width="500px" v-model="dialogVisible" @opened="onDialogOpen" center label-width="" :lock-scroll="false" :close-on-click-modal="false">
                    <el-row>
                        <el-text class="mx-1">訂單編號:{{ form.WORK_NO }}</el-text>
                    </el-row>
                    <el-row>
                        <el-text class="mx-1">託運單號:{{ form.DLV_NO }}</el-text>
                    </el-row>
                    <el-row style="justify-content: center; align-items: center; padding: 10px;">
                        <el-col :span="7" :offset="1" v-for="item in imgForm">
                            <el-image :src="getImageUrl(item.FILE_NAME)"></el-image>
                        </el-col>
                    </el-row>
                </el-dialog>
            </div>

            <!-- 貨況區塊 -->
            <el-dialog width="600px" v-model="dialogVisible2" @opened="onDialogOpen" center label-width="" :lock-scroll="false" :close-on-click-modal="false">
                <el-row>
                    <el-text class="mx-1">訂單編號:{{ form.WORK_NO }}</el-text>
                </el-row>
                <el-row>
                    <el-text class="mx-1">託運單號:{{ form.DLV_NO }}</el-text>
                </el-row>
                <el-table :data="statusForm" :max-height="scrollbar_H">
                    <el-table-column width="150" property="STATUS_NAME" label="作業狀態" />
                    <el-table-column width="180" property="STATUS_TIME" label="作業時間" />
                    <el-table-column width="200" property="REMARKS" label="備註說明" />
                </el-table>
            </el-dialog>
        </div>
    </transition>

    <!-- 匯入運單 -->
    <transition name="el-fade-in-linear">
        <div v-show="showOrder" class="transition-box">
            <div id="formblock">
                <el-form label-position="top" label-width="80px" :model="searchForm">
                    <el-row justify="space-between" style="width: 100%">
                        <el-col :span="20">
                            <el-form-item label="訂單資料檔:">
                                <el-row :gutter="10" style="width: 100%">
                                    <el-col :span="6">
                                        <el-input v-model="uploadForm.FILE_NAME" readonly />
                                    </el-col>
                                    <el-col :span="8">
                                        <el-upload ref="uploadRef" :auto-upload="false" :limit="1" :on-change="onChangeFile" accept=".xlsx, .xls" :show-file-list="false">
                                            <template #trigger>
                                                <el-button type="primary" plain>選取檔案</el-button>
                                            </template>

                                            <div class="el-upload el-upload--text" style="margin-left: 5px">
                                                <el-button type="primary" plain @click="onExampleDownload">下載範本檔</el-button>
                                            </div>
                                        </el-upload>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10" style="width: 100%; margin-top: 5px">
                                    <el-col :span="3">
                                        <el-text type="primary">總資料筆數:{{uploadForm.TOTAL_COUNT}}</el-text>
                                    </el-col>
                                    <el-col :span="3">
                                        <el-text type="primary">勾選筆數:{{uploadForm.CHECKED_COUNT}}</el-text>
                                        <br />
                                        <el-text type="primary">錯誤筆數:{{uploadForm.ERROR_COUNT}}</el-text>
                                    </el-col>
                                    <el-col :span="3">
                                        <el-button type="primary" plain @click="onImportData">匯入資料</el-button>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="info" plain round @click="onPageChangeClick('main')" style="float: right">
                                <el-icon><ArrowLeft /></el-icon>
                                返回
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div id="datablock" style="height: calc(100vh - 400px)">
                <div ref="tableExcel"></div>
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { h, ref, onMounted, nextTick } from 'vue';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessageBox, ElInput, ElText } from 'element-plus'
    import { useDownload } from '@/composables/download'
    import SearchBar from '@/components/SearchBar.vue'
    import axios from 'axios';
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();
    const picUrl = ref(null); //圖片網址位置

    const showMain = ref(true);//顯示主頁面
    const showOrder = ref(false); //顯示匯入訂單頁面
    const dialogTitle = ref('');//dialog標題
    const dialogVisible = ref(false);//顯示dialog[配達照片或簽收圖檔]
    const dialogVisible2 = ref(false);//顯示dialog[貨況區塊]
    const IDdisabled = ref(false);//編輯時ID狀態
    const formData = ref(null);
    const imgForm = ref(null);//托運單圖檔

    const form = ref({
        DLV_NO: '',
        WORK_NO: '',
    });

    const uploadModel = {
        FILE_NAME: '',
        TOTAL_COUNT: 0,
        CHECKED_COUNT: 0,
        ERROR_COUNT: 0,
    };

    const uploadForm = ref({ ...uploadModel });

    const searchRef = ref(null);
    const statusForm = ref(null);

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table
    const tableExcel = ref(null);
    const tabulatorExcel = ref(null);

    const onLoadTable = (data) => {
        $api.GET('/api/DlvNote/GetTableData', data
        ).then((response) => {
            tabulator.value.setData(response);
        });
    }

    const onPageChangeClick = (value) => {
        showMain.value = !showMain.value;
        showOrder.value = !showOrder.value;

        switch (value) {
            case "main":
                CreateMainTable();
                break;

            case "order":
                uploadForm.value = { ...uploadModel };
                CreateOrderTable();
                break;
        }
    }

    const onExportClick = () => {
        $api.POST('/api/DlvNote/ExportExcel', {
            type: "track", param: searchRef.value.searchForm
        }).then((response) => {
            useDownload('/api/Home/DownloadFile?URL_ADDR=' + response, response.split('\\')[1]);
        });
    }

    const onDialogOpen = () => {
        nextTick(() => {
            form.value = formData.value;
        })
    }

    const uploadRef = ref(null);
    const onChangeFile = (file) => {
        var postForm = new FormData();
        postForm.append("CUST_CODE", searchRef.value.searchForm.CUST_CODE);
        postForm.append("file", file.raw);
        $api.UPLOAD('/api/DlvNote/CheckExcel', postForm).then((response) => {
            if (response.length == 1 && response[0].WORK_NO == "0") {
                ElMessageBox.alert("表頭檢查失敗", "提示", { confirmButtonText: "確定" });
                return;
            }

            uploadForm.value.FILE_NAME = file.name;
            uploadForm.value.TOTAL_COUNT = response.length;
            uploadForm.value.ERROR_COUNT = response.filter(row => row.ERROR_MSG).length;
            uploadRef.value.clearFiles();
            tabulatorExcel.value.setData(response);
        });
    }

    const onExampleDownload = () => {
        // 檔案相對路徑Mu
        const filePath = 'Template/A100.xlsx';

        const link = document.createElement('a');
        link.href = filePath;
        link.download = "Delivery_Template.xlsx";
        link.click();
    }

    const onImportData = async () => {
        const selectedData = tabulatorExcel.value.getSelectedData();
        if (selectedData.length == 0) {
            ElMessageBox.alert('請勾選項目', '提示', { confirmButtonText: "確定" });
            return;
        }

        $api.GET("/api/Home/GetUrl", {
            url: "Api"
        }).then(async (response) => {
            const apiUrl = await response;

            var errMsg = "";
            (async function () {
                for await (const data of selectedData) {
                    try {
                        const token = await getToken(apiUrl, data.CLIENT_ID, data.CLIENT_SECRET);
                        const res = await callCreateApi(apiUrl, token, data);
                        console.log(`${data.WORK_NO}: `, res);

                        if (res.status == 200) {
                            tabulatorExcel.value.deleteRow(data.WORK_NO);
                        }
                    }
                    catch (error) {
                        errMsg += `<span class="el-text el-text--primary">${data.WORK_NO}</span>: ${JSON.stringify(error.response?.data?.message || error.message)}<br/>`;
                        console.error("Error calling API: ", error);
                    };
                };

                console.log(errMsg);

                if (errMsg != "") {
                    ElMessageBox.alert(errMsg, "提示", {
                        type: 'warning',
                        cancelButtonText: "確定",
                        dangerouslyUseHTMLString: true
                    });
                } else {
                    ElMessageBox.alert("匯入成功", "提示", {
                        type: 'success',
                        cancelButtonText: "確定",
                        dangerouslyUseHTMLString: true
                    });
                }

            })();
        });
    }

    const getToken = async (apiUrl, CLIENT_ID, CLIENT_SECRET) => {
        const param = {
            client_id: CLIENT_ID,
            client_secret: CLIENT_SECRET,
            grant_type: "client_credentials"
        };

        const response = await axios({
            method: 'post',
            url: apiUrl + "/oauth2/connect/token",
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data: param
        });

        return response.data.access_token;
    }

    const callCreateApi = async (apiUrl, token, data) => {
        const postData = {
            "client_order_id": data.WORK_NO,
            "sender": {
                "store_id": data.DEPT_COMP_ID,
                "brand_name": data.BRAND_NAME,
                "name": data.NAME,
                "phone_no": data.PHONE_NO,
                "contact": "",
                "location": {
                    "address": data.ADDRESS,
                    "longitude": Number(data.DEPT_LONG),
                    "latitude": Number(data.DEPT_LATI),
                    "zipcode": ""
                },
                "notes": data.REMARKS_LOAD
            },
            "recipient": {
                "name": data.DEST_COMP_NAME,
                "phone_no": data.DEST_TEL_NO,
                "location": {
                    "address": data.DEST_ADDR,
                    "longitude": Number(data.DEST_LONG),
                    "latitude": Number(data.DEST_LATI),
                    "zipcode": ""
                },
                "notes": ""
            },
            "est_ready_time": `${data.DEPT_TIME} ${data.DEPT_PERIOD}`,
            "est_pickup_time": `${data.DEPT_TIME} ${data.DEPT_PERIOD}`,
            "coldbag_needed": "",
            "collect_amount": Number(data.COLLECT_AMT),
            "goods_description": data.GOODS_DESC,
            "goods_amount": Number(data.PRODUCT_AMT),
            "goods_items": [
                {
                    "name": data.GOODS_DESC,
                    "quantity": Number(data.QTY),
                    "quantity_um": (data.QTY_UM ?? "份"),
                    "weight": 0,
                    "amount": 0,
                    "u_amount": 0
                }
            ],
            "cancel_action": "leave_at_door",
            "delivery_platform": "MT",
            "courier_num": Number(data.COURIER_NUM)
        };

        const response = await axios({
            method: 'post',
            url: apiUrl + "/mete_oauth_api/api/Order/CreateOrder",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: postData
        });

        return response;
    }

    const onDetailClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));

        $api.GET('/api/DlvNoteStatus/GetStatus', {
            DLV_SEQ: cell.getRow().getData().DLV_SEQ
        }).then((response) => {
            statusForm.value = response;
            dialogVisible2.value = true;
        });
    }

    const onPicClick = (e, cell) => {
        formData.value = JSON.parse(JSON.stringify(cell.getData()));

        $api.GET('/api/DlvNoteImg/GetTableData', {
            DLV_SEQ: cell.getRow().getData().DLV_SEQ
        }).then((response) => {
            imgForm.value = response;
            dialogVisible.value = true;
        });
    };

    const getImageUrl = (FILE_URL) => {
        return picUrl.value + 'photos/' + FILE_URL;
    }

    const DetailIcon = (cell, formatterParams, onRendered) => {
        var container = document.createElement('button');
        container.setAttribute('id', cell.getRow().getData().WORK_NO);
        container.setAttribute('class', 'el-button');
        container.setAttribute('type', 'button');
        container.setAttribute('v-popover', 'popoverRef');
        container.setAttribute('aria-disabled', 'false');
        container.setAttribute('style', 'font-size: 20px; padding: 5px;');
        var icon = '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path fill="currentColor" d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"></path></svg></i>';
        container.innerHTML = icon;

        return container;
    };

    const ReportIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-029747aa=""><path fill="currentColor" d="M192 128v768h640V128H192zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32zm160 448h384v64H320v-64zm0-192h192v64H320v-64zm0 384h384v64H320v-64z"></path></svg></i>';
    };

    const CreateMainTable = () => {
        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 392px)", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            headerVisible: false,
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            columns: [
                { title: "序號", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                {
                    title: "", field: "WORK_NO", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // 時間格式 MM/DD hh:mm:ss
                        var datetime = new Date(cell.getRow().getData().LAST_STATUS_TIME).toLocaleString([], { month: "2-digit", day: "2-digit", hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
                        return cell.getValue() + '<br/>' + cell.getRow().getData().LAST_STATUS + ': ' + datetime;
                    }
                },
                { title: "TRN_LGS", field: "TRN_LGS", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                {
                    title: "", field: "DEPT_COMP_NAME", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        return cell.getValue() + '-' + cell.getRow().getData().DEST_COMP_NAME + '<br/>' + cell.getRow().getData().DEST_ADDR;
                    }
                },
                { title: "", field: "detail", formatter: DetailIcon, width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false, cellClick: onDetailClick },
                { title: "PIC", field: "pic", formatter: ReportIcon, width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false, cellClick: onPicClick }
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
        tabulator.value.on("tableBuilt", function () {
            if (!store.getters.check_auth('MODIFY')) {
                //tabulator.value.hideColumn('edit');
            }
        });
    }

    const CreateOrderTable = () => {
        tabulatorExcel.value = new Tabulator(tableExcel.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "calc(100vh - 400px)", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            pagination: false,       //paginate the data
            rowFormatter: function (row) {
                const rowData = row.getData();
                const rowCell = row.getCell("select");
                if (rowData.ERROR_MSG) {
                    row.getElement().style.backgroundColor = "#FFEC9E";
                    rowCell.getElement().children[0].disabled = true;
                }
            },
            index: "WORK_NO",
            columns: [
                { title: "序號", formatter: "rownum", width: 40, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                {
                    title: "", titleFormatter: "rowSelection", titleFormatterParams: { rowRange: "active" },
                    field: "select", formatter: "rowSelection",
                    width: 40, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false
                },
                {
                    title: "訊息", field: "ERROR_MSG", width: 40, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false,
                    formatter: function (cell) {
                        if (cell.getValue()) {
                            return "<button class='el-button el-button--danger is-text' style='padding: 5px 10px; height:auto;background:transparent'>@</button>";
                        }
                    },
                    cellClick: function (e, cell) {
                        if (cell.getValue()) {
                            ElMessageBox({
                                title: "[錯誤訊息]",
                                message: () =>
                                    h(ElInput, {
                                        type: "textarea",
                                        value: cell.getValue(),
                                        readonly: true,
                                        rows: 5,
                                    }),
                                confirmButtonText: "關閉",
                                confirmButtonClass: "el-button--info",
                                center: true,
                                closeOnClickModal: false
                            });
                        }
                    }
                },
                { title: "訂單/出貨單號", field: "WORK_NO", width: 120, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "出貨門市代號", field: "DEPT_COMP_ID", width: 100, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "出貨門市名稱", field: "GOODS_OWNER_NAME", width: 100, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "收件人", field: "DEST_COMP_NAME", width: 100, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "收件-地址", field: "DEST_ADDR", width: 180, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "收件-聯絡人", field: "DEST_CONTACT", width: 100, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "收件-電話", field: "DEST_TEL_NO", width: 100, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "取件日期", field: "DEPT_TIME", width: 90, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "取件時段", field: "DEPT_PERIOD", width: 70, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "取件注意事項", field: "REMARKS_LOAD", width: 150, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "貨品說明", field: "GOODS_DESC", width: 100, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "數量", field: "QTY", width: 50, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false },
                { title: "數量單位", field: "QTY_UM", width: 70, headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                { title: "商品價值", field: "PRODUCT_AMT", width: 70, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false },
                { title: "外送人數", field: "COURIER_NUM", width: 70, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                { title: "代收貨款", field: "COLLECT_AMT", width: 70, headerHozAlign: "center", hozAlign: "right", vertAlign: "middle", headerSort: false },
                { title: "物流運輸公司", field: "TRANS_COMP", width: 100, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
            ],
        });

        tabulatorExcel.value.on("rowSelected", function (row) {
            const rowData = row.getData();
            if (rowData.ERROR_MSG) {
                row.deselect();
            } else {
                row.select();
            }
        });

        tabulatorExcel.value.on("rowSelectionChanged", function (data, rows) {
            uploadForm.value.CHECKED_COUNT = data.length;
        });
    }

    onMounted(() => {
        // 取得圖片網址位置
        $api.GET('/api/Home/GetUrl', {
            url: "picUrl"
        }).then((res) => {
            picUrl.value = res;
        });

        CreateMainTable();
    });

</script>

<style></style>
